import { render } from "./ViewTopNav.vue?vue&type=template&id=1ca7e4a5"
import script from "./ViewTopNav.vue?vue&type=script&lang=js"
export * from "./ViewTopNav.vue?vue&type=script&lang=js"

import exportComponent from "F:\\PWAs\\yves-pwa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__